import { render } from "./Record.vue?vue&type=template&id=4e51ba9a&scoped=true&ts=true"
import script from "./Record.vue?vue&type=script&lang=ts"
export * from "./Record.vue?vue&type=script&lang=ts"

import "./Record.vue?vue&type=style&index=0&id=4e51ba9a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e51ba9a"]])

export default __exports__